import { jsx as _jsx } from "react/jsx-runtime";
import { AppText } from '@streem/ui-react';
export const TooltipMessage = ({ text, }) => {
    return (_jsx(AppText, { color: "grey80", size: "small", children: text }));
};
//# sourceMappingURL=toolbar_tooltip_message.js.map